import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-18" }, "Buscar Pedidos de Compra")
], -1)
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "visualizar",
  title: "Importado"
}
const _hoisted_7 = ["title"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["title"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = {
  key: 5,
  style: {"margin-right":"5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_card = _resolveComponent("card")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1000,
    centered: "",
    "wrap-class-name": "ss-modal-compras",
    destroyOnClose: true
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_selecionar_pessoa, {
                  codigoSelecionado: _ctx.props.codigoFornecedor,
                  empresas: [_ctx.props.empresa],
                  classCss: "ss-largura-total",
                  disabled: true
                }, null, 8, ["codigoSelecionado", "empresas"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_spin, {
          spinning: _ctx.state.importando,
          tip: "Aguarde por favor..."
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_table, {
              loading: _ctx.state.buscandoPedidos,
              columns: _ctx.state.colunasGrade.filter(item => item.visible),
              "data-source": _ctx.state.pedidos,
              rowKey: "codigo",
              pagination: false,
              size: "small",
              rowClassName: "ss-table-campos",
              bordered: ""
            }, {
              emptyText: _withCtx(() => [
                _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhuma Nota fiscal foi encontrada!" })
              ]),
              bodyCell: _withCtx(({ column, record }) => [
                (column.key === 'acoes')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      ((!record.importado))
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "visualizar",
                            title: "Importar",
                            onClick: ($event: any) => (_ctx.confirmar(record.codigo, record.numeroPedido))
                          }, [
                            _createVNode(_component_icone, {
                              style: {"font-size":"18px"},
                              nome: "download"
                            })
                          ], 8, _hoisted_5))
                        : _createCommentVNode("", true),
                      ((record.importado))
                        ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
                            _createVNode(_component_icone, {
                              style: {"font-size":"18px"},
                              nome: "correto-circulo"
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (column.key === 'NumeroPedido')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (record.numeroPedido > 0)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              title: record.numeroPedido
                            }, _toDisplayString(record.numeroPedido), 9, _hoisted_7))
                          : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
                      ], 64))
                    : (column.key === 'NumeroPedidoFornecedor')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          (record.numeroPedidoFornecedor > 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                title: record.numeroPedidoFornecedor
                              }, _toDisplayString(record.numeroPedidoFornecedor), 9, _hoisted_9))
                            : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
                        ], 64))
                      : (column.key === 'DataCriacao')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 3,
                            title: _ctx.UtilitarioData.aplicaFormatoData(record.dataCriacao)
                          }, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataCriacao)), 9, _hoisted_11))
                        : (column.key === 'DataPrevisaoEntrega')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 4,
                              title: _ctx.UtilitarioData.aplicaFormatoData(record.dataPrevisaoEntrega)
                            }, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataPrevisaoEntrega)), 9, _hoisted_12))
                          : (column.key === 'TotalPedido')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.totalPedido, 2, true)), 1))
                            : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["loading", "columns", "data-source"])
          ]),
          _: 1
        }, 8, ["spinning"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}